import { getFullName } from '../../Admin/components/transaction-management/customerTable';
import api from '../api';

export const allTransactionsInfo = async (page) => {
    
        const res = await api.get(`/job/getAllTransactionsInfo${page ? '?page=' + page : ''}`);
        const rows=  res.data.data;
        console.log("rows", rows)
        const transactions = rows.map((job) => ({
                serviceRequestId: job._id,
                serviceTypes: job.serviceDetail.service, // Convert array to comma-separated string
                homeowner: {
                  username: job.houseOwnerId?.userName || "N/A",
                  fullName: job.houseOwnerId ? getFullName(job.houseOwnerId) : "N/A",
                },
                shoveler: {
                  username: job.ShovelerInfo[0]?.ShovelerId?.userName || "N/A",
                  fullName: job.ShovelerInfo[0]?.ShovelerId ? getFullName(job.ShovelerInfo[0]?.ShovelerId) : "N/A",
                },
                payment: {
                  offered: job.paymentInfo.amount || 0,
                  authorized: job.paymentInfo.amount || 0, // Assuming full authorization
                  captured: job.paymentInfo.status === "capture" ? job.paymentInfo.amount : 0,
                },
                payoutStatus: job.ShovelerInfo[0]?.PayoutStatus || "Pending",
              }));
        return transactions;
    
}
